<ng-container [formGroup]="formGroup">
  <ng-container [formArrayName]="arrayControlName">
    @for (
      otherConservationActvitiesFormGroup of getFormArray()?.controls;
      track i;
      let i = $index
    ) {
      <section [formGroupName]="i">
        @let formGroupAlertShouldBeVisible = submitted && !isFormGroupValid(i);
        <section>
          <div
            class="card mb-4"
            [ngClass]="
              formGroupAlertShouldBeVisible
                ? 'border-danger border-2'
                : 'card-border-color-from-db'
            "
          >
            <div
              class="card-header card-header-color-from-db d-flex justify-content-between"
            >
              <span class="mr-2"
                >{{
                  'MONUMENT_CONSERVATION_GRANT_REQUEST.OTHER_CONSERVATION_ACTIVITIES.TITLE'
                    | translate
                }}
                #{{ i + 1 }}
              </span>
              <div>
                <button
                  (click)="deleteFormControl(i)"
                  type="button"
                  title="minus"
                  class="btn btn-danger btn-sm py-0 text-nowrap"
                >
                  <i class="fa fa-times me-2"></i>
                  <strong>{{ 'REMOVE' | translate }}</strong>
                </button>
              </div>
            </div>

            <div class="card-body">
              <div class="row">
                <div class="col-lg col-md-12">
                  <label class="mb-0" [attr.for]="controlName.Year">
                    {{
                      'MONUMENT_CONSERVATION_GRANT_REQUEST.OTHER_CONSERVATION_ACTIVITIES.YEAR'
                        | translate
                    }}
                  </label>

                  <input
                    type="number"
                    [name]="controlName.Year"
                    [id]="controlName.Year"
                    class="form-control form-control-sm required"
                    [formControlName]="controlName.Year"
                    (keypress)="validateIntegerInput($event)"
                  />
                </div>
                <div class="col-lg col-md-12">
                  <label class="mb-0" [attr.for]="controlName.ScopeOfWork">
                    {{
                      'MONUMENT_CONSERVATION_GRANT_REQUEST.OTHER_CONSERVATION_ACTIVITIES.SCOPE_OF_WORK'
                        | translate
                    }}
                  </label>

                  <input
                    type="text"
                    [name]="controlName.ScopeOfWork"
                    [id]="controlName.ScopeOfWork"
                    class="form-control form-control-sm required"
                    [formControlName]="controlName.ScopeOfWork"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-lg col-md-12">
                  <label class="mb-0" [attr.for]="controlName.Expenses">
                    {{
                      'MONUMENT_CONSERVATION_GRANT_REQUEST.OTHER_CONSERVATION_ACTIVITIES.EXPENSES'
                        | translate
                    }}
                  </label>

                  <input
                    type="text"
                    [name]="controlName.Expenses"
                    [id]="controlName.Expenses"
                    class="form-control form-control-sm required"
                    [formControlName]="controlName.Expenses"
                  />
                </div>
                <div class="col-lg col-md-12">
                  <label
                    class="mb-0"
                    [attr.for]="controlName.PublicFundsSubsidies"
                  >
                    {{
                      'MONUMENT_CONSERVATION_GRANT_REQUEST.OTHER_CONSERVATION_ACTIVITIES.PUBLIC_FUNDS_SUBSIDIES'
                        | translate
                    }}
                  </label>

                  <input
                    type="text"
                    [name]="controlName.PublicFundsSubsidies"
                    [id]="controlName.PublicFundsSubsidies"
                    class="form-control form-control-sm required"
                    [formControlName]="controlName.PublicFundsSubsidies"
                  />
                </div>
              </div>
            </div>

            @if (formGroupAlertShouldBeVisible) {
              <div class="card-footer">
                <div class="alert alert-danger my-2">
                  {{ 'FIELDS_REQUIRED' | translate }}
                </div>
              </div>
            }
          </div>
        </section>
      </section>
    }
  </ng-container>

  <section>
    <div class="card card-border-color-from-db mb-4">
      <div class="card-header card-header-color-from-db">
        {{
          'MONUMENT_CONSERVATION_GRANT_REQUEST.OTHER_CONSERVATION_ACTIVITIES.TITLE'
            | translate
        }}
      </div>

      <div class="card-body d-grid">
        <button
          (click)="addFormControl()"
          type="button"
          title="plus"
          class="btn btn-lg btn-outline-dark fa fa-plus"
        ></button>
      </div>
    </div>
  </section>
</ng-container>
